import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import { API_BASE } from '../../config/api';
import './AdminBookings.css';

const STATUS_OPTIONS = [
  { value: 'not_paid', label: 'غير مدفوع', color: '#dc3545' },
  { value: 'paid', label: 'مدفوع', color: '#28a745' },
  { value: 'onhold', label: 'معلق', color: '#ffc107' },
  { value: 'done', label: 'منجز', color: '#17a2b8' },
  { value: 'ended', label: 'منتهي', color: '#6c757d' },
];

const AdminBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(null);

  useEffect(() => {
    loadBookings();
  }, []);

  const loadBookings = () => {
    const token = localStorage.getItem('adminToken');
    if (!token) {
      console.error('No admin token found');
      setLoading(false);
      return;
    }
    
    console.log('Fetching bookings from:', `${API_BASE}/api/admin/bookings`);
    axios
      .get(`${API_BASE}/api/admin/bookings`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log('Bookings response:', res.data);
        setBookings(res.data.bookings || []);
      })
      .catch((err) => {
        console.error('Error fetching bookings:', err);
        console.error('Error response:', err.response?.data);
        console.error('Error status:', err.response?.status);
        setBookings([]);
      })
      .finally(() => setLoading(false));
  };

  const updateStatus = async (bookingId, newStatus) => {
    const token = localStorage.getItem('adminToken');
    if (!token) return;
    
    setUpdating(bookingId);
    try {
      await axios.patch(
        `${API_BASE}/api/admin/bookings/${bookingId}`,
        { status: newStatus },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // Update local state
      setBookings((prev) =>
        prev.map((b) => (b.id === bookingId ? { ...b, status: newStatus } : b))
      );
    } catch (err) {
      console.error('Status update error:', err);
      alert(err.response?.data?.error || 'فشل تحديث الحالة');
    } finally {
      setUpdating(null);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    // Handle ISO date string
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString('ar-EG', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const getStatusInfo = (status) => {
    return STATUS_OPTIONS.find((s) => s.value === status) || STATUS_OPTIONS[0];
  };

  if (loading) return <div className="admin-loading">جاري التحميل...</div>;

  return (
    <div className="admin-bookings">
      <h1 className="admin-page-title">الحجوزات</h1>
      {bookings.length === 0 ? (
        <div className="admin-empty">لا توجد حجوزات</div>
      ) : (
        <div className="admin-bookings-table-wrap">
          <table className="admin-bookings-table">
            <thead>
              <tr>
                <th>التاريخ</th>
                <th>الوقت</th>
                <th>العميل</th>
                <th>الجوال</th>
                <th>الخدمة</th>
                <th>السعر</th>
                <th>الحالة</th>
              </tr>
            </thead>
            <tbody>
              {bookings.map((b) => {
                const statusInfo = getStatusInfo(b.status || 'not_paid');
                return (
                  <tr key={b.id} className={`booking-row booking-row-${b.status || 'not_paid'}`}>
                    <td>{formatDate(b.booking_date)}</td>
                    <td>{b.slot_time}</td>
                    <td>
                      <strong>{b.guest_name}</strong>
                      {b.guest_email && (
                        <a href={`mailto:${b.guest_email}`} className="admin-email-link">
                          <FaEnvelope size={12} />
                        </a>
                      )}
                    </td>
                    <td>
                      {b.guest_phone && (
                        <a href={`tel:${b.guest_phone}`} className="admin-phone-link">
                          <FaPhone size={12} /> {b.guest_phone}
                        </a>
                      )}
                    </td>
                    <td>{b.service_header || b.service_name || '-'}</td>
                    <td>{b.price ? `${b.price} ريال` : '-'}</td>
                    <td>
                      <select
                        value={b.status || 'not_paid'}
                        onChange={(e) => updateStatus(b.id, e.target.value)}
                        disabled={updating === b.id}
                        className="admin-status-select"
                        style={{ 
                          backgroundColor: statusInfo.color + '20',
                          color: statusInfo.color,
                          borderColor: statusInfo.color
                        }}
                      >
                        {STATUS_OPTIONS.map((opt) => (
                          <option key={opt.value} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminBookings;
